import type { FunnelData } from '../types'

interface GclidFunnelProps {
  funnel: FunnelData
}

export function GclidFunnel({ funnel }: GclidFunnelProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Lead Funnel</h3>

      <div className="space-y-4">
        {/* Total Calls - Base */}
        <div className="relative">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-medium text-gray-700">Total Calls</span>
            <span className="text-sm text-gray-500">100% BASE</span>
          </div>
          <div className="h-10 bg-blue-500 rounded-lg flex items-center px-3">
            <span className="text-white font-bold text-lg">{funnel.total_calls || funnel.paid_calls}</span>
          </div>
        </div>

        {/* Arrow down */}
        <div className="flex justify-center">
          <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>

        {/* Relevant Calls */}
        <div className="relative">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-medium text-gray-700">Relevant Calls</span>
            <span className="text-sm text-emerald-600 font-medium">{funnel.relevant_rate}% RELEVANT RATE</span>
          </div>
          <div
            className="h-10 bg-emerald-500 rounded-lg flex items-center px-3"
            style={{ width: `${Math.max(funnel.relevant_rate, 20)}%` }}
          >
            <span className="text-white font-bold text-lg">{funnel.relevant_calls}</span>
          </div>
        </div>

        {/* Arrow down */}
        <div className="flex justify-center">
          <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>

        {/* Booked */}
        <div className="relative">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-medium text-gray-700">Booked</span>
            <span className="text-sm text-purple-600 font-medium">{funnel.booking_rate}% BOOKING RATE</span>
          </div>
          <div
            className="h-10 bg-purple-500 rounded-lg flex items-center px-3"
            style={{ width: `${Math.max(funnel.booking_rate, 10)}%` }}
          >
            <span className="text-white font-bold text-lg">{funnel.booked_calls}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
